import { ApplicationForm } from "../model/applications";

const toNumberOrNull = (value: unknown): number | null => {
  if (value === null || value === undefined) return null;
  const s = String(value).trim();
  if (s === "") return null;
  const n = Number(s);
  return Number.isNaN(n) ? null : n;
};

const toIdOrNull = (value: unknown): number | null => {
  if (value === null || value === undefined) return null;
  const s = String(value).trim();
  if (s === "") return null;
  const n = Number(s);
  return Number.isNaN(n) ? null : n;
};

const toStringSafe = (value: unknown): string => {
  if (value === null || value === undefined) return "";
  return String(value);
};

export function normalizeApplicationForm(values: any): ApplicationForm {
  const normalized: ApplicationForm = {
    name: toStringSafe(values?.name).trim(),
    customer_id: toIdOrNull(values?.customer_id),
    project_id: toIdOrNull(values?.project_id),
    legal_entity_id: toIdOrNull(values?.legal_entity_id),
    profile_id: toIdOrNull(values?.profile_id),
    candidate_grade: Array.isArray(values?.candidate_grade)
      ? values.candidate_grade.map((v: any) => String(v))
      : [],
    candidate_requirements: toStringSafe(values?.candidate_requirements),
    job_duties: toStringSafe(values?.job_duties),
    project_description: toStringSafe(values?.project_description),
    bitrix_contract_link: toStringSafe(values?.bitrix_contract_link),
    sales_max_offer_general: toStringSafe(values?.sales_max_offer_general),
    sales_max_offer_regions: toStringSafe(values?.sales_max_offer_regions),
    sales_max_offer_moscow: toStringSafe(values?.sales_max_offer_moscow),
    marginality: toNumberOrNull(values?.marginality),
    purchase_rate_max: toStringSafe(values?.purchase_rate_max),
    required_number: toNumberOrNull(values?.required_number),
    location: toStringSafe(values?.location),
    job_format: toStringSafe(values?.job_format),
    office_address: toStringSafe(values?.office_address),
    job_workload: toStringSafe(values?.job_workload),
    attraction_period: toStringSafe(values?.attraction_period),
    comments: toStringSafe(values?.comments),
    attachments: Array.isArray(values?.attachments) ? (values.attachments as File[]) : [],
    attachments_delete: Array.isArray(values?.attachments_delete)
      ? values.attachments_delete.map((v: any) => String(v))
      : [],
    status: toIdOrNull(values?.status) as unknown as number,
  };

  return normalized;
}


